export default __webpack_public_path__ + "static/media/datenschutzerklaerunge-bike-boerse.7d5f923b.pdf";